<template>
  <v-card flat class="rounded-lg">
    <v-card-title class="profile-card-title">دفترچه آدرس ها</v-card-title>
    <v-divider class="mx-4 my-0"/>

    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card outlined class="rounded-lg d-flex">

            <div style="flex: 1 1 0">
              <v-card-title>
                آدرس 1
              </v-card-title>
              <v-card-text>
                خیابان خرم، چهارراه شهیدان
              </v-card-text>
            </div>

            <div class="ma-2 rounded-lg overflow-hidden">
              <mapir style="width: 300px;height: 200px" :center="center"
                     :apiKey="apiKey">
                <!--                <mapNavigationControl position="top-right"/>-->
                <!--                <mapMarker-->
                <!--                    :coordinates.sync="data.coordinates"-->
                <!--                    color="red"-->
                <!--                    readonly-->
                <!--                    type="marker"-->
                <!--                    kind="marker"-->
                <!--                />-->
              </mapir>
            </div>

          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGeolocateControl, mapir, mapMarker, mapNavigationControl} from "mapir-vue";
import axios from "axios";

export default {
  name: "profileAddresses",

  components: {mapGeolocateControl, mapir, mapMarker, mapNavigationControl},

  data: () => ({
    apiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0',
    center: [51.420296, 35.732379]
  }),

  mounted() {
    this.getLatLng()
  },

  methods: {
    getLatLng() {
      axios({
        method: 'GET',
        baseURL: 'https://map.ir/reverse',
        params: {lat: 35.732379, lon: 51.420296},
        timeout: 15000,
        headers: {
          'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg',
          Accept: 'application/json',
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        console.log('address res : ', response);
      });
    },
  }
}
</script>

<style scoped lang="scss">
.profile-card-title {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: dodgerblue;
    border-radius: 8px;
  }
}
</style>